import type React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ResizableTextarea from "../../../components/ui/ResizableTextArea";
import { tokens } from "../../../theme";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface TermsAndConditionsSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const TermsAndConditionsSection: React.FC<TermsAndConditionsSectionProps> = ({
  value,
  onChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const reduxTheme = useSelector((state: RootState) => state.theme);
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Terms and Conditions
      </Typography>

      <ResizableTextarea
        label="Terms and Conditions"
        value={value}
        onChange={onChange}
        colors={colors}
        reduxTheme={reduxTheme}
        placeholder="Enter terms and conditions for this proposal..."
      />
    </Box>
  );
};

export default TermsAndConditionsSection;
